import React, { useState } from "react";
import { ScrollPanel } from "primereact/scrollpanel";
import { Accordion, AccordionTab } from "primereact/accordion";

const DialogFAQsBox: React.FC<{ FAQData: any[] }> = ({ FAQData }) => {
  const [expandedIndexes, setExpandedIndexes] = useState<number[]>([]);

  return (
    <ScrollPanel style={{ width: "auto", overflow: "auto" }}>
      <Accordion
        multiple
        activeIndex={expandedIndexes}
        onTabChange={(e) =>
          setExpandedIndexes(Array.isArray(e.index) ? e.index : [e.index])
        }
      >
        {FAQData
          .filter((item) => item.Display_type !== "QnA_FreeFormText")
          .map((item: any, index: number) => (
            <AccordionTab
              key={item.Conf_key}
              header={
                <div className="d-flex align-items-center w-100">
                  <span className="me-2 fw-bold">
                    {item.Conf_key || "Untitled Question"}
                  </span>
                </div>
              }
            >
              <div className="mt-2">
                {item.Display_type === "QnA_HTML" ? (
                  <div dangerouslySetInnerHTML={{ __html: item.Conf_value }} />
                ) : (
                  <p>{item.Conf_value}</p>
                )}
              </div>
            </AccordionTab>
          ))}
      </Accordion>
    </ScrollPanel>
  );
};

export default DialogFAQsBox;